import React from 'react'
import { useLingui } from '@lingui/react/macro'

import { XStack } from 'tamagui'
import { Metadata } from '@newComponents/Metadata'
import { GradientBackgroundScreen } from '@newComponents/Screen'
import { Card } from '@newComponents/Card'

import { useScreenMessages } from '@data/i18n'

import { EventNewContent } from './EventNewContent'

const loadCatalog = (locale: string) => import(/* webpackChunkName: "locale-event-new-screen-[request]" */ `./locales/${locale}.po`)

export const EventNewScreen = () => {
  const { t } = useLingui()
  useScreenMessages(loadCatalog)

  return (
    <>
      <Metadata title={t`New Event`} />
      <GradientBackgroundScreen>
        <XStack justifyContent='center'>
          <Card maxWidth={600} flex={1} padding='$8' borderRadius='$14'>
            <EventNewContent />
          </Card>
        </XStack>
      </GradientBackgroundScreen>
    </>
  )
}

export default EventNewScreen
